<template>
  <div id="answer" class="answer-ie-11">
    <span class="accessibility-hide-text" ref="pageIndicator" tabindex="1">
      {{ labels.question }}
      {{ page.current }}
      {{ labels.of }}
      {{ page.total }}
    </span>

    <h4 tabindex="2" class="text-question">
      {{ currentQuestion.text }}
    </h4>

    <span class="accessibility-hide-text" tabindex="3">
      {{ questionTitle }}
    </span>

    <SlideNumber
      v-if="['nps', 'slide-number'].includes(currentQuestion.type)"
      :question="currentQuestion"
      :key="currentQuestion.question_id"
      @answer="answer"
      class="max-width"
    />

    <StarRating
      v-if="currentQuestion.type == 'stars'"
      :question="currentQuestion"
      @answer="answer"
    />

    <RadioString
      v-if="currentQuestion.type == 'select'"
      :question="currentQuestion"
      @answer="answer"
    />

    <CheckBoxString
      v-if="currentQuestion.type == 'multi-select'"
      :question="currentQuestion"
      @answer="answer"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SlideNumber from './SlideNumber.vue'
import StarRating from './StarRating.vue'
import CheckBoxString from './CheckBoxString.vue'
import RadioString from './RadioString.vue'

const props = {
  question: {
    type: Object,
    required: true,
  },
  page: {
    type: Object,
    required: true,
  },
}

const components = {
  SlideNumber,
  StarRating,
  CheckBoxString,
  RadioString,
}

export default {
  components: components,
  props: props,
  mounted() {
    this.$refs.pageIndicator.focus()
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.answer
    },
    currentQuestion() {
      return JSON.parse(JSON.stringify(this.question))
    },
    questionTitle() {
      const title = this.resources.page.survey.warningMessage

      if (this.currentQuestion.type === 'percent') {
        return [title, this.labels.percentualTooltip].join(' ')
      }

      return [
        title,
        this.currentQuestion.answers.length,
        this.labels.optionsPresented,
      ].join(' ')
    },
  },
  methods: {
    answer(id) {
      this.$emit('answer', id)
    },
  },
}
</script>

<style lang="scss" scoped>
_:-ms-fullscreen,
:root .answer-ie-11 {
  display: block !important;
}

#answer {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  .max-width {
    margin: 0 auto;
    max-width: 1000px;
    min-width: 80%;
    min-height: 270px;

    @media (max-width: 767px) {
      justify-content: center;
    }
  }
}

.text-question {
  font-weight: 500;
  margin-bottom: 3rem;

  @media (max-width: 767px) {
    font-size: medium;
    margin-bottom: 0.5rem !important;
  }
}
</style>
